export const uploadDocApis = {
    getUploadDoc: 'v1/api/uploadDoc?userId=',
    createUploadDoc: 'v1/api/uploadDoc',
    editUploadDoc: 'v1/api/uploadDoc',
    deleteUploadDoc: 'v1/api/uploadDoc',
};
